// extracted by mini-css-extract-plugin
module.exports = {"SystemManagementSettings":"SystemManagementSettings_SystemManagementSettings__3W4YC"};